/* src/app/components/header/header.component.scss */
@font-face {
  font-family: "e-ukraine";
  src: url("./media/e-Ukraine-Light.otf") format("opentype");
  font-weight: 300;
  font-display: swap;
  font-style: normal;
}
@font-face {
  font-family: "e-ukraine";
  font-style: normal;
  src: url("./media/e-Ukraine-Regular.woff") format("woff");
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "e-ukraine";
  font-style: normal;
  src: url("./media/e-Ukraine-Medium.woff") format("woff");
  font-weight: 500;
  font-display: swap;
}
@font-face {
  font-family: "e-ukraine-heading";
  font-style: normal;
  src: url("./media/e-UkraineHead-Regular.woff") format("woff");
  font-weight: 400;
  font-display: swap;
}
:root {
  --1px: 1px;
  --1pxFont: 1px;
  --vw: 1vw;
  --vh: 1vh;
  --index: calc(var(--vw) + var(--vh));
  --ion-font-family: "e-ukraine";
  --ion-font-family-head: "e-ukraine-head";
  --ion-default-font: "e-ukraine";
  --accessibility-font-scale: 1;
  --accessibility-container-scale: 1;
  --primary-background-color-light: #ffffff;
  --primary-background-color-light-rgb:
    250,
    250,
    251;
  --primary-background-color-dark: #333232ff;
  --primary-background-color-dark-rgb:
    51,
    50,
    50;
  --primary-color-light: #000000;
  --primary-color-light-rgb:
    0,
    0,
    0;
  --primary-color-dark: #000000;
  --primary-color-dark-rgb:
    0,
    0,
    0;
  --primary-color-light-shade: #000000;
  --primary-color-light-tint: #000000;
  --secondary-color: #7a7a7a;
  --opacity-color: #808080;
  --list-item-color-light: #ffffff;
  --list-item-color-dark: #ffffff;
  --chip-active-color-light: var(--primary-color);
  --chip-active-color-dark: var(--primary-color);
  --chip-active-background-color-light: #d1faf9;
  --chip-active-background-color-dark: #d1faf9;
  --chip-success-color-light: #13c26e;
  --chip-success-color-dark: #13c26e;
  --chip-success-background-color-light: #d1fae6;
  --chip-success-background-color-dark: #d1fae6;
  --chip-error-color-light: #cf1f29;
  --chip-error-color-dark: #cf1f29;
  --chip-error-background-color-light: #f8d3d5;
  --chip-error-background-color-dark: #f8d3d5;
  --chip-warning-color-light: #f75200;
  --chip-warning-color-dark: #f75200;
  --chip-warning-background-color-light: #ffe5cc;
  --chip-warning-background-color-dark: #ffe5cc;
  --list-item-color-text-light: #474a52;
  --list-item-color-text-dark: #bfc2cb;
  --segment-bg-color-light: #fafafb;
  --segment-bg-color-dark: #fafafb;
  --chip-background-color-light: #d1faf9;
  --chip-background-color-dark: #575249;
  --second-text-color-light: #ec6608;
  --second-text-color-dark: #ec6608;
  --third-text-color-light: #798492;
  --third-text-color-dark: #798492;
  --primary-field-background-color-light: #e8fdfc;
  --primary-field-background-color-dark: #222325;
  --primary-field-background-color-danger-light: rgb(235 192 192);
  --primary-field-background-color-danger-dark: #ebc0c04f;
  --primary-card-background-color-light: #e7dfe6;
  --primary-card-background-color-dark: #757575;
  --primary-color-focused-light: #a2f6f4;
  --primary-color-focused-dark: #ffd373;
  --second-text-color: var(--second-text-color-light);
  --third-text-color: var(--text-color-secondary);
  --disabled-color: #d9d9d9;
  --unactive-color: #eaeaea;
  --default-font-weight: 400;
  --medium-font-weight: 500;
  --ligth-font-weight: 300;
  --bold-font-weight: 800;
  --background-color: var(--primary-background-color-light);
  --background-color-rgb: var(--primary-background-color-light-rgb);
  --text-color: var(--text-color-primary);
  --text-color-inverse: var(--text-color-primary);
  --text-color-rgb: var(--text-color-primary);
  --primary-field-background-color: var(--primary-field-background-color-light);
  --list-item-color: var(--list-item-color-light);
  --primary-color: var(--primary-color-light);
  --ion-color-primary: var(--primary-color-light);
  --ion-color-primary-shade: var(--primary-color-light-shade);
  --ion-color-primary-tint: var(--primary-color-light-tint);
  --ion-color-shade: var(--primary-color-light-shade);
  --ion-color-tint: var(--primary-color-light-shade);
  --primary-color-inverse: var(--primary-color-dark);
  --primary-color-rgb: var(--primary-color-light-rgb);
  --primary-color-focused: var(--primary-color-focused-light);
  --primary-card-background-color: var(--primary-card-background-color-light);
  --list-item-color-text: var(--list-item-color-text-light);
  --segment-bg-color: var(--segment-bg-color-light);
  --chip-background-color: var(--chip-background-color-light);
  --chip-active-color: var(--chip-active-color-light);
  --chip-active-background-color: var(--chip-active-background-color-light);
  --chip-success-color: var(--chip-success-color-light);
  --chip-success-background-color: var(--chip-success-background-color-light);
  --chip-error-color: var(--chip-error-color-light);
  --chip-error-background-color: var(--chip-error-background-color-light);
  --chip-warning-color: var(--chip-warning-color-light);
  --chip-warning-background-color: var(--chip-warning-background-color-light);
  --primary-field-background-color-danger: var(--primary-field-background-color-danger-light);
  --ion-color-secondary: var(--secondary-color);
  --ion-item-background: var(--background-color);
  --ion-background-color: var(--background-color);
  --state-draft-color: #bebebe;
  --state-processing-color: #dbb83abd;
  --state-done-color: #56799f;
  --state-error-color: #b70e0eab;
  --ion-color-warning: #dd900d;
  --ion-color-warning-rgb:
    221,
    144,
    13;
  --ion-color-danger: #d42620;
  --ion-color-danger-rgb:
    212,
    38,
    32;
  --custom-line-height: 1.36;
  --custom-blue: var(--primary-color);
  --custom-l-blue: #d5e0e6;
  --custom-alice-blue: #ebeff2;
  --custom-light-blue: #8597a5;
  --custom-error: #d42620;
  --custom-warning: #ef9a9a;
  --custom-light-text-color: #ffffff;
  --custom-schedule-active: #deebf8;
  --custom-schedule-active-second: #bccedf;
  --custom-schedule-disabled: #ededed;
  --custom-schedule-bg: #e0e0e0;
  --custom-swipe-color: #5679a4c2;
  --custom-marker-color: #e20300;
  --custom-active-event-bg: #ffffff;
  --custom-end-event-bg: #f6f7f9;
  --custom-primary: #56799f;
  --custom-link-color: #0471eb;
  --custom-accent-color: #f39100;
  --custom-accent-toggle: #4caf50;
  --custom-corporate-color: #5679a4;
  --custom-dark-text-color: #000000;
  --custom-light-bg-color: #ffffff;
  --custom-app-bg-color: #f9fafe;
  --custom-btn-outline: #dbdbdb;
  --custom-grey-text-color: #7d7d7d;
  --custom-title-text-color: #1d1d1d;
  --custom-disabled-color-bg: #bfbfbf;
  --custom-disabled-color-text: #00000057;
  --custom-disabled-color-full-bg: #bfbfbf;
  --custom-disabled-color-full-text: #00000057;
  --custom-modals-border-radius: calc(var(--1px) * 16);
  --ion-color-dark: var(--custom-dark-text-color);
  --ion-margin: calcToPixels(20);
  --custom-info-block-background-color: #fff4d7;
  --custom-info-block-icon-color: #ffd200;
  --primary-gradient:
    linear-gradient(
      0deg,
      #ffa800,
      #ffa800),
    linear-gradient(
      313.54deg,
      #ffa800 55.18%,
      rgba(255, 255, 255, 0.2) 55.18%);
  --blue-gradient:
    linear-gradient(
      325.19deg,
      #1569b3 50.2%,
      rgba(255, 255, 255, 0.2) 50.2%),
    linear-gradient(
      0deg,
      #1569b3,
      #1569b3);
  --default-background:
    linear-gradient(
      180.38deg,
      #eff9ff 24.85%,
      #ffffff 65.31%);
  --light-blue-gradient:
    linear-gradient(
      180deg,
      #daf1ff 0%,
      #f3fafe 100%);
  --ion-color-primary: #000000;
  --ion-color-primary-rgb:
    0,
    0,
    0;
  --ion-color-primary-contrast: #000000;
  --ion-color-primary-contrast-rgb:
    0,
    0,
    0;
  --ion-color-primary-shade: #000000;
  --ion-color-primary-tint: #000000;
  --ion-color-date: #736b66;
  --ion-color-bg-blue: #f3fafe;
  --ion-color-bg-light-blue: #daf1ff;
  --ion-color-bg-yellow: #fff9eb;
  --ion-select-text-color: #101928;
  --ion-color-disabled: #c8c8c8;
  --ion-bg-item-disabled: #f0f2f5;
  --ion-bg-button-secondary-disabled: #edeeef;
  --ion-bg-header-light-blue: #f1f7fe;
  --ion-goods-color: #474f60;
  --header-background: #e7eef3;
  --header-text-color: #ffffff;
  --heading-1-size: calc(var(--1pxFont) * 56);
  --heading-2-size: calc(var(--1pxFont) * 38);
  --heading-3-size: calc(var(--1pxFont) * 32);
  --heading-4-size: calc(var(--1pxFont) * 28);
  --heading-5-size: calc(var(--1pxFont) * 24);
  --heading-6-size: calc(var(--1pxFont) * 20);
  --heading-line-height: 120%;
  --heading-letter-spacing: 0px;
  --text-color-primary: #000000;
  --text-color-secondary: #7f7f7f;
  --text-color-secondary-grey: #e7eef3;
  --text-color-white: #ffffff;
  --text-color-primary-rgb:
    0,
    0,
    0;
  --text-color-secondary-rgb:
    143,
    155,
    179;
  --text-color-white-rgb:
    255,
    255,
    255;
  --text-color-light-green: #5fc381;
  --text-color-green: #409d31;
  --text-color-red: #d42620;
  --text-color-red-light: #e26e6a;
  --text-color-blue: #1569b3;
  --text-color-yellow: #e99c07;
  --text-color-yellow-light: #ff9500;
  --text-color-grey: #8e8e93;
  --text-error-btn-color: #e4122e;
  --text-error-btn-border: #e4122e;
  --text-color-progress-value: #2b3674;
  --text-color-secondary-light: #b2b2b2;
  --text-color-chart-label: #474b4e;
  --bg-color-white: #ffffff;
  --bg-color-status-green: #0f973d;
  --bg-color-status-orange: #faa61a;
  --bg-color-status-red: #d42620;
  --bg-color-status-grey: #8f9bb3;
  --bg-color-status-blue: #1569b3;
  --bg-progress-bar-green: #0f973d;
  --bg-progress-bar-grey: #f0f2f5;
  --bg-chart-series: #34b3f1;
  --form-field-border-color: #000000;
  --form-field-background: #ffffff;
  --form-field-error-color: var(--text-color-red);
  --form-field-error-border-color: #e26e6a;
  --form-field-valid-border-color: #000000;
  --form-field-icon-color: #98a2b3;
  --form-field-gradient: #000000;
  --form-track-background-checked: #89c2f0;
  --form-track-background: #e4e7ec;
  --toolbar-height: calc(var(--1px) * 56);
  --mat-form-field-container-text-font: "e-ukraine";
  --mat-select-trigger-text-font: "e-ukraine";
  --mat-option-label-text-font: "e-ukraine";
  --mat-table-row-item-label-text-font: "e-ukraine";
  --mat-table-header-headline-font: "e-ukraine";
  --mat-table-row-item-label-text-size: calc(var(--1px) * 13);
  --mat-option-label-text-size: calc(var(--1px) * 16);
  --mat-paginator-select-trigger-text-size: calc(var(--1px) * 16);
  --mat-option-selected-state-layer-color: var(--ion-color-secondary);
  --mat-option-hover-state-layer-color: var(--ion-color-secondary);
  --mat-table-row-item-outline-color: var(--ion-color-secondary);
  --mat-table-row-item-outline-width: 2px;
  --mat-table-row-item-label-text-weight: 300;
  --low-price-text-color: #2e7d32;
  --low-price-bg-color: #e9f7ef;
}
.ion-color-primary-light {
  --ion-color-base: var(--ion-bg-header-light-blue, #f1f7fe) !important;
  --ion-color-base-rgb: var(--ion-color-light-rgb, 241, 247, 248) !important;
  --ion-color-contrast: var(--ion-color-light-contrast, #000) !important;
  --ion-color-contrast-rgb: var(--ion-color-light-contrast-rgb, 0, 0, 0) !important;
  --ion-color-shade: var(--ion-color-light-shade, #f1f7fe) !important;
  --ion-color-tint: var(--ion-color-light-tint, #f1f7fe) !important;
}
:root h1,
:root h2,
:root h3,
:root h4,
:root h5,
:root h6 {
  margin: 0;
  padding: 0;
  line-height: var(--heading-line-height) !important;
  letter-spacing: var(--heading-letter-spacing) !important;
}
:root h1 {
  font-size: var(--heading-1-size) !important;
}
:root h2 {
  font-size: var(--heading-2-size) !important;
}
:root h3 {
  font-size: var(--heading-3-size) !important;
}
:root h4 {
  font-size: var(--heading-4-size) !important;
}
:root h5 {
  font-size: var(--heading-5-size) !important;
}
:root h6 {
  font-size: var(--heading-6-size) !important;
}
ion-content h1 {
  font-size: var(--heading-1-size) !important;
}
ion-content h2 {
  font-size: var(--heading-2-size) !important;
}
ion-content h3 {
  font-size: var(--heading-3-size) !important;
}
ion-content h4 {
  font-size: var(--heading-4-size) !important;
}
ion-content h5 {
  font-size: var(--heading-5-size) !important;
}
ion-content h6 {
  font-size: var(--heading-6-size) !important;
}
:root {
  --ion-color-secondary: #e7eef3;
  --ion-color-secondary-rgb:
    231,
    238,
    243;
  --ion-color-secondary-contrast: #e7eef3;
  --ion-text-color: #000000;
  --text-extra: calc(var(--1pxFont) * 38);
  --text-big: calc(var(--1pxFont) * 24);
  --text-large: calc(var(--1pxFont) * 18);
  --text-medium: calc(var(--1pxFont) * 16);
  --text-small: calc(var(--1pxFont) * 14);
  --text-xsmall: calc(var(--1pxFont) * 12);
  --line-height-text: 145%;
  --line-height-caption: 120%;
  --letter-spacing-text: 0;
  --letter-spacing-caption-large: 12%;
  --letter-spacing-caption-small: 12%;
  --letter-spacing-caption-xsmall: 16%;
}
@media (max-width: 767px) {
  :root {
    --heading-1-size: calc(var(--1pxFont) * 26);
    --heading-2-size: calc(var(--1pxFont) * 24);
    --text-extra: calc(var(--1pxFont) * 20);
    --text-big: calc(var(--1pxFont) * 16);
    --text-large: calc(var(--1pxFont) * 14);
    --text-medium: calc(var(--1pxFont) * 14);
    --text-small: calc(var(--1pxFont) * 11);
    --text-xsmall: calc(var(--1pxFont) * 9);
    --mat-paginator-select-trigger-text-size: calc(var(--1px) * 13);
  }
}
.accessibility-high-contrast {
  --ion-color-primary: #ffffff;
  --ion-color-primary-rgb:
    255,
    255,
    255;
  --ion-color-primary-contrast: #000000;
  --ion-color-primary-contrast-rgb:
    0,
    0,
    0;
  --ion-color-primary-shade: #e6e6e6;
  --ion-color-primary-tint: #ffffff;
  --background-color: #000000;
  --background-color-rgb:
    0,
    0,
    0;
  --ion-background-color: #000000;
  --ion-item-background: #000000;
  --text-color-primary: #ffffff;
  --text-color-secondary: #ffffff;
  --text-color-primary-rgb:
    255,
    255,
    255;
  --text-color-secondary-rgb:
    255,
    255,
    255;
  --ion-text-color: #ffffff;
  --ion-color-dark: #ffffff;
  --text-color-chart-label: #ffffff;
  --form-field-background: #000000;
  --form-field-border-color: #ffffff;
  --primary-field-background-color: #000000;
  --custom-dark-text-color: #ffffff;
  --form-field-valid-border-color: #ffffff;
  --ion-select-text-color: #ffffff;
  --text-color-white: #000000;
  --mat-sort-arrow-color: #ffffff;
  --mat-paginator-container-background-color: #000000;
  --mat-paginator-container-text-color: #ffffff;
  --mat-select-enabled-trigger-text-color: #ffffff;
  --mat-select-panel-background-color: #000000;
  --mat-table-row-item-outline-color: #ffffff;
  --mat-option-selected-state-layer-color: #ffffff;
  --mat-option-selected-state-label-text-color: #000000;
  --mat-option-label-text-color: #ffffff;
  --form-field-error-color: #ffffff;
  --mdc-filled-text-field-input-text-color: #ffffff;
  --mdc-filled-text-field-error-active-indicator-color: #ffffff;
  --highlight-color-invalid: #ffffff;
  --ion-color-danger: #ffffff;
  --form-field-error-border-color: #ffffff;
  --secondary-color: #ffffff;
  --mdc-filled-text-field-container-color: #ffffff;
  --opacity-color: #ffffff;
  --mdc-filled-text-field-hover-active-indicator-color: #ffffff;
  --mdc-filled-text-field-error-hover-active-indicator-color: #ffffff;
  --mat-autocomplete-background-color: #000000;
  --low-price-text-color: #ffffff;
  --low-price-bg-color: #ffffff;
  --bg-chart-series: #ffffff;
  --custom-info-block-background-color: #000000;
  --custom-info-block-icon-color: #ffffff;
  --ion-color-secondary: #000000;
  --ion-color-secondary-rgb:
    0,
    0,
    0;
  --ion-color-secondary-contrast: #000000;
  --custom-link-color: #ffffff;
  --second-text-color: #ffffff;
  --third-text-color: #ffffff;
  --list-item-color: #000000;
  --list-item-color-text: #ffffff;
  --header-background: #000000;
  --header-text-color: #ffffff;
  --bg-color-white: #000000;
  --primary-color: #ffffff;
}
.accessibility-high-contrast .perpage-container .mat-mdc-paginator-container .mat-mdc-paginator-page-size .mat-mdc-paginator-page-size-select .mdc-text-field--no-label.mdc-text-field--focused::after {
  background: var(--primary-color);
}
.accessibility-high-contrast .breadcrumbs a,
.accessibility-high-contrast .breadcrumbs ol,
.accessibility-high-contrast .breadcrumbs li[_ngcontent-ng-c4090235686] + li[_ngcontent-ng-c4090235686]::before {
  color: #ffffff;
}
.accessibility-high-contrast .form-row .form-control {
  --highlight-color: #ffffff !important;
}
.accessibility-high-contrast .perpage-container .mat-mdc-paginator-container .mat-mdc-paginator-page-size .mat-mdc-paginator-page-size-label {
  color: #ffffff;
}
.accessibility-high-contrast .ngx-pagination a,
.accessibility-high-contrast .ngx-pagination button {
  color: #ffffff;
}
.accessibility-high-contrast .ngx-pagination a:hover,
.accessibility-high-contrast .ngx-pagination button:hover {
  background: transparent;
}
.accessibility-high-contrast .item-radio-checked.sc-ion-select-popover-md {
  --background: #ffffff;
}
.accessibility-high-contrast ion-icon {
  color: #ffffff !important;
  fill: #ffffff !important;
}
.accessibility-high-contrast ion-button {
  --color: #ffffff;
  color: #ffffff;
  --background: #000000;
  --border-color: #ffffff;
}
.accessibility-high-contrast ion-button[fill=solid] {
  --background: #ffffff;
  --color: #000000;
}
.accessibility-high-contrast ion-button[fill=outline] {
  --border-color: #ffffff;
  --color: #ffffff;
  color: #ffffff;
}
.accessibility-high-contrast ion-button[fill=clear] {
  --color: #ffffff;
  color: #ffffff;
}
.accessibility-high-contrast ion-input,
.accessibility-high-contrast ion-textarea,
.accessibility-high-contrast ion-select {
  --background: #000000;
  --color: #ffffff;
  --border-color: #ffffff;
}
.accessibility-high-contrast ion-card {
  --background: #000000;
  --color: #ffffff;
  border: 1px solid #ffffff;
}
.accessibility-high-contrast ion-item {
  --background: #000000;
  --color: #ffffff;
  --border-color: #ffffff;
}
.accessibility-high-contrast ion-modal,
.accessibility-high-contrast ion-popover {
  --background: #000000;
  --color: #ffffff;
}
.accessibility-high-contrast table,
.accessibility-high-contrast .data-table {
  background-color: #000000 !important;
  color: #ffffff !important;
}
.accessibility-high-contrast table th,
.accessibility-high-contrast table td,
.accessibility-high-contrast .data-table th,
.accessibility-high-contrast .data-table td {
  background-color: #000000 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
}
.accessibility-high-contrast .first-page-view tr[data-index="0"] td,
.accessibility-high-contrast .first-page-view tr[data-index="1"] td,
.accessibility-high-contrast .first-page-view tr[data-index="2"] td {
  background-color: #ffffff !important;
  color: #000000 !important;
  border-color: #000000 !important;
}
.accessibility-high-contrast .first-page-view tr[data-index="0"] td .icon-low-price,
.accessibility-high-contrast .first-page-view tr[data-index="1"] td .icon-low-price,
.accessibility-high-contrast .first-page-view tr[data-index="2"] td .icon-low-price {
  display: flex !important;
  color: #000000 !important;
  fill: #000000 !important;
}
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="0"] .ncodp-item,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="1"] .ncodp-item,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="2"] .ncodp-item {
  background-color: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
  --text-color-secondary: #000000;
}
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="0"] .ncodp-item .mat-column-limitPriceOfUnit,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="1"] .ncodp-item .mat-column-limitPriceOfUnit,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="2"] .ncodp-item .mat-column-limitPriceOfUnit {
  color: #000000 !important;
  display: flex;
  align-items: center;
}
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="0"] .ncodp-item .mat-column-limitPriceOfUnit .icon-low-price,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="1"] .ncodp-item .mat-column-limitPriceOfUnit .icon-low-price,
.accessibility-high-contrast .first-page-view ncodp-list-item[data-id="2"] .ncodp-item .mat-column-limitPriceOfUnit .icon-low-price {
  display: flex;
  color: #000000 !important;
  fill: #000000 !important;
}
.accessibility-high-contrast .gradient-border {
  border-image: none;
  border-color: #ffffff;
}
.accessibility-high-contrast .info-medication-item span {
  color: #ffffff !important;
}
.accessibility-high-contrast ncodp-info-block .info {
  background-color: transparent !important;
  border: 1px solid #ffffff;
}
.accessibility-high-contrast .ion-color-light {
  --ion-color-light: #000000;
  --ion-color-contrast: #ffffff !important;
}
.accessibility-high-contrast ion-accordion {
  border-color: #ffffff;
  --ion-color-contrast: #ffffff !important;
}
.accessibility-high-contrast ion-segment-button {
  --color: #ffffff;
  --custom-light-text-color: #000000;
}
.accessibility-high-contrast ion-segment-button ion-icon {
  color: inherit !important;
  fill: inherit !important;
}
.accessibility-high-contrast .ncodp-item {
  border-color: #ffffff !important;
}
.accessibility-high-contrast .input-wrapper.sc-ion-input-ios {
  --background: transparent;
}
.accessibility-high-contrast .logo-icon {
  --blue: #ffffff !important;
  --yellow: #ffffff !important;
}
.accessibility-high-contrast .dynamic-desc {
  opacity: 1;
  color: var(--text-color-primary);
}
:host .logo-icon {
  --blue: #2e3191;
  --yellow: #ffca05;
}
:host a {
  font-size: 0;
}
.accessibility-btn {
  --color: var(--ion-color-dark, #222428);
  --padding-start: calc(var(--1px) * 8);
  --padding-end: calc(var(--1px) * 8);
  margin-right: calc(var(--1px) * 10);
}
.accessibility-btn .accessibility-text {
  font-size: calc(var(--1pxFont) * 18);
}
/*# sourceMappingURL=header.component.css.map */
